@if (userType === "broker" && !thirdPartyUsers) {
  <div class="cart-price-container cart-list-button">
    <a [routerLink]="['/shopping-cart/cart']"
      ><em class="far fa-shopping-cart"></em
    ></a>
    <span class="total">{{ cartTotal | currency }}</span>
  </div>
}
